/**
 * OEmbed Media Player
 * Converts <oembed url="..."> tags to playable iframes (YouTube, Vimeo).
 * No server-side requests - constructs embed URLs from watch URLs.
 */

interface EmbedResult {
    src: string;
}

function getEmbedUrl(url: string): EmbedResult | null {
    const trimmed = url.trim();

    // YouTube: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID
    const youtubeMatch = trimmed.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/
    );
    if (youtubeMatch) {
        return {
            src: `https://www.youtube.com/embed/${youtubeMatch[1]}`,
        };
    }

    // Vimeo: vimeo.com/ID, player.vimeo.com/video/ID
    const vimeoMatch = trimmed.match(
        /vimeo\.com\/(?:video\/)?(\d+)/
    );
    if (vimeoMatch) {
        return {
            src: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
        };
    }

    return null;
}

function replaceOembed(element: Element): void {
    const url =
        element.getAttribute('url') ||
        element.getAttribute('data-oembed-url');
    if (!url) return;

    const embed = getEmbedUrl(url);
    if (!embed) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'oembed-embed-wrapper';

    const iframe = document.createElement('iframe');
    iframe.src = embed.src;
    iframe.title = 'Video embed';
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');

    wrapper.appendChild(iframe);
    element.replaceWith(wrapper);
}

export function initOembedMediaPlayer(): void {
    const oembeds = document.querySelectorAll('oembed[url], oembed[data-oembed-url]');
    oembeds.forEach(replaceOembed);
}
